/**
 * The honest "nothing good today" state (constitution §I) — never a padded list.
 *
 * The body is the server's own sentence when it sent one. `build_view` writes a
 * note that fits the actual situation, and replacing it with a fixed banner
 * throws away the only honest thing on the screen (constitution §VI). The
 * translated line is the fallback for a dry day the server had no words for.
 *
 * This renders only when `dry_day` is true. A non-empty `message` on a day that
 * *has* cards is a different thing and belongs above them — see `Dashboard.tsx`.
 *
 * PIVOT-142: this used to be the quietest thing the system could draw — a
 * dashed hairline, centred, at `--text-soft`, and an `h3` even though nothing
 * in between it and the page's `h1` ever rendered an `h2` on this branch
 * (`Dashboard.tsx` only renders a list's `h2` when that list is non-empty, and
 * a dry day has none). It is `h2` now, closing that heading-order skip, and
 * styled as the most prominent thing on the page — see DryDayNotice.css —
 * because on a dry day this notice *is* the page.
 */

import { useI18n } from '../i18n'
import './DryDayNotice.css'

interface DryDayNoticeProps {
  /** `MatchesResponse.message`, verbatim. `''` falls back to the translated line. */
  message?: string
}

export function DryDayNotice({ message }: DryDayNoticeProps) {
  const { t } = useI18n()
  return (
    <div className="dry-day-notice">
      <h2>{t('dashboard.dryDayTitle')}</h2>
      <p>{message || t('dashboard.dryDayBody')}</p>
    </div>
  )
}
